import {useMutation} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {type CreateEsimOrderRequestPayload} from '@guestapp/sdk';
import {useIsMounted} from '../common';

type Props = {
  onError?: (error: Error) => void;
};
function useMutateEsimOrders({onError}: Props = {}) {
  const {createEsimOrder} = useChekinSDK();
  const isMounted = useIsMounted();

  return useMutation<unknown, Error, CreateEsimOrderRequestPayload[]>(
    requests => Promise.all(requests.map(request => createEsimOrder(request))),
    {
      onError: error => {
        if (!isMounted.current) {
          return;
        }
        onError?.(error);
      },
    },
  );
}

export {useMutateEsimOrders};
